<template>
    <div class="ReBPCheckLead">
        <div>
            ReBPCheckLead тут мы попробуем запросить в лиде фильтры для создания услуги, а запросить настройки создания услуги в процессе, после чего сопоставить.
            <input type="number" class="form-control" placeholder="Укажите номер лида" v-model.lazy="leadId" :required="true" step="1"/>
            <base-button @click="check()"  type="success" simple>Проверить</base-button>
        </div>
        <div style="width:100%">
            <el-table
                :data="table"
                style="width: 100%;"
                ref="table"
                :cell-class-name="tableCellClassName"
            >
                <el-table-column 
                    v-for="(c,i) in columns"
                    :key="i"
					:label="c"
					:property="String(i)"
				></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import { Table, TableColumn } from 'element-ui';

    export default {
        name: 'ReBPCheckLead',
        data(){
            return {
                leadId: '',
                show: false,
                bp:{},
                services:[],
                columns:{},
                table:[],
                fields:{
                    'LeadSource_list':'источник лида',
                    'operTypeId':'пит операции',
                    'objType_list':'тип объекта',
                    'adsSourceId_list':'реклама',
                    'quality':'качестенный',
                    'isNewBuilding':'новостройка',
                    'isObjects':'По объекта',
                    'anotherCompanyAgent':'Агент др комп',
                    'profileCode':'Профиль',
                    'OTDEL_ID':'отдел',
                },
            }
        },
        components: {
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,            
        },
        props:{
            value: String
        },
        methods:{
            tableCellClassName(params){
                // console.log(row, columnIndex);
                if(params.columnIndex<2) return '';
                if(params.row[1]==''||params.row[1]=='-1') return '';

                if(params.row[0]==this.fields.OTDEL_ID){
                    if(params.row[params.columnIndex] && params.row[params.columnIndex].split(',').indexOf(params.row[1])==-1){
                        return 'field-error';
                    }
                }else{
                    
                    if(params.row[1]!=params.row[params.columnIndex]){
                        return 'field-error';
                    }
                }
            },
            check(){
                this.show = true;
                this.$GVO.ApiCall('GET_SERVICE_PARAMS',{obj:'LEAD',flt:{
                    id:this.leadId,
                    BP_ID: this.value
                }})
                    .then((objApi) => {
                        if(objApi.success){
                            // console.log('LEAD.GET_SERVICE_PARAMS',objApi);
                            // let lead = objApi.data[0].service_data
                            this.bp=objApi.data[0].bp_data;
                            this.services=objApi.data[0].service_data;
                            this.buildTable()
                        }
                    })
                    .catch(errorObjApi => console.error(errorObjApi));                
            },
            buildTable(){
                let table = [];
                let row;
                
                Object.keys(this.fields).forEach(field=>{
                    // console.log(field);
                    row=[this.fields[field], this.bp[field]];
                    this.services.forEach(serv=>{
                        // console.log(serv,field);
                        row.push(serv[field])
                    });
                    table.push(row);
                });
                this.columns=['Поле', 'БП'];
                if(this.services.length>1){
                    this.services.forEach((serv,index)=>{
                        this.columns.push('Лид '+(index+1));
                    })
                }else{
                    this.columns.push('Лид');
                }
                // console.log(table);
                this.table = table;
            }
        }
    }
</script>
<style>
    .ReBPCheckLead .el-table--enable-row-transition .el-table__body td.field-error{
        background-color: #fcc;
    }
</style>